module.exports = __webpack_public_path__ + "static/media/apply-mtc-mobile.fc189e3e.png";